import React from 'react';
import PropTypes from 'prop-types';
import { FDPrimaryActionButton } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import SubmitNextUpReviewPageWithActionItemsConfirmationDialog
  from 'Views/Page/Content/Templates/FacetPlanProposalNextUpReviewPageTemplate/SendProposalButtonWithModal/SubmitNextUpReviewPageWithActionItemsConfirmationDialog';

export default function FacetPlanProposalNextUpReviewPageTemplate({
  resource,
  loading,
  disabled,
  open,
  onClose,
  onClick,
  onSubmit,
}) {
  return (
    <React.Fragment>
      <FDPrimaryActionButton
        label={'Send to Member'}
        onClick={onClick}
        loading={loading}
        disabled={disabled}
        {...dataAttrs('send-proposal-button')}
      />
      <SubmitNextUpReviewPageWithActionItemsConfirmationDialog
        resource={resource}
        open={open}
        onConfirm={onSubmit}
        onClose={onClose}
        loading={loading}
      />
    </React.Fragment>
  );
}

FacetPlanProposalNextUpReviewPageTemplate.defaultProps = {
};

FacetPlanProposalNextUpReviewPageTemplate.propTypes = {
  resource: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
